import React from "react";
import { inp, Field } from "../biz/ui";
import { STATUSES } from "./i18n";

export const TextIn = ({ label, value, onChange, testid, area, dir, type = "text", rows = 3 }) => (
  <Field label={label}>
    {area
      ? <textarea dir={dir} rows={rows} value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} className={inp} />
      : <input dir={dir} type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} className={inp} />}
  </Field>
);

export const Check = ({ label, checked, onChange, testid }) => (
  <label className="flex items-start gap-2.5 text-sm text-[#3A342C] cursor-pointer">
    <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} data-testid={testid} className="mt-0.5 w-4 h-4 accent-[#9A7445]" />
    <span>{label}</span>
  </label>
);

export const StatusSelect = ({ t, value, onChange, testid }) => (
  <Field label={t("status")}>
    <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid} className={inp}>
      {STATUSES.map((s) => <option key={s} value={s}>{t(`s_${s}`)}</option>)}
    </select>
  </Field>
);

const TONES = { available: "bg-[#E7F1E4] text-[#2F6B2A]", sold_out: "bg-[#F6E3DF] text-[#A33A2B]", draft: "bg-[#EFEAE2] text-[#6B645A]", archived: "bg-[#EFEAE2] text-[#6B645A]" };
export const StatusPill = ({ t, status }) => (
  <span className={`text-xs rounded-full px-2.5 py-1 ${TONES[status] || "bg-[#F3ECE1] text-[#7A5A33]"}`}>{t(`s_${status}`)}</span>
);

export const pair = (t, p, set, key, opts = {}) => (
  <div className="grid md:grid-cols-2 gap-3">
    <TextIn {...opts} dir="ltr" label={t(`${key}_en`)} value={p[`${key}_en`]} onChange={(v) => set(`${key}_en`, v)} testid={`lab-f-${key}-en`} />
    <TextIn {...opts} dir="rtl" label={t(`${key}_ar`)} value={p[`${key}_ar`]} onChange={(v) => set(`${key}_ar`, v)} testid={`lab-f-${key}-ar`} />
  </div>
);
